var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jet-authentication-card",
    {
      scopedSlots: _vm._u([
        {
          key: "logo",
          fn: function () {
            return [_c("jet-authentication-card-logo")]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-4 text-sm text-gray-600" },
        [
          !_vm.recovery
            ? [
                _vm._v(
                  "\n            Please confirm access to your account by entering the\n            authentication code provided by your authenticator application.\n        "
                ),
              ]
            : [
                _vm._v(
                  "\n            Please confirm access to your account by entering one of your\n            emergency recovery codes.\n        "
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("jet-validation-errors", { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          !_vm.recovery
            ? _c(
                "div",
                [
                  _c("jet-label", { attrs: { for: "code", value: "Code" } }),
                  _vm._v(" "),
                  _c("jet-input", {
                    ref: "code",
                    staticClass: "mt-1 block w-full",
                    attrs: {
                      id: "code",
                      type: "text",
                      inputmode: "numeric",
                      autofocus: "",
                      autocomplete: "one-time-code",
                    },
                    model: {
                      value: _vm.form.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code",
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("jet-label", {
                    attrs: { for: "recovery_code", value: "Recovery Code" },
                  }),
                  _vm._v(" "),
                  _c("jet-input", {
                    ref: "recovery_code",
                    staticClass: "mt-1 block w-full",
                    attrs: {
                      id: "recovery_code",
                      type: "text",
                      autocomplete: "one-time-code",
                    },
                    model: {
                      value: _vm.form.recovery_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "recovery_code", $$v)
                      },
                      expression: "form.recovery_code",
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center justify-end mt-4" },
            [
              _c(
                "button",
                {
                  staticClass:
                    "text-sm text-gray-600 hover:text-gray-900 underline cursor-pointer",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleRecovery.apply(null, arguments)
                    },
                  },
                },
                [
                  !_vm.recovery
                    ? [_vm._v(" Use a recovery code ")]
                    : [_vm._v(" Use an authentication code ")],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "jet-button",
                {
                  staticClass: "ml-4",
                  class: { "opacity-25": _vm.form.processing },
                  attrs: { disabled: _vm.form.processing },
                },
                [_vm._v("\n                Log in\n            ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }